module.exports = __webpack_public_path__ + "img/flavor4.6f736c6e.png";